var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#338AF3;}\n\t.st1{fill:#6DA544;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#FFDA44;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.7,233.7c0,0-158.6,203.3-158.8,203.3c46.3,46.3,110.3,75,181,75c141.4,0,256-114.6,256-256L233.7,233.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.7,256c0,0-158.6-181.1-158.8-181C121.3,28.7,185.3,0,256,0c141.4,0,256,114.6,256,256H233.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,75C-25,175-25,337,75,437c0,0,437-181,437-181L75,75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.6,150.3c-49.1,0-89,39.9-89,89v33.4c0,49.1,39.9,89,89,89s89-39.9,89-89v-33.4 C222.6,190.2,182.7,150.3,133.6,150.3L133.6,150.3z M189.2,272.7c0,24.9-16.4,46-39,53.1v-36.4l23.6-23.6l-23.6-23.6l0-8.4v-11.1 h-33.4V256l-23.6,23.6l23.6,23.6v22.6c-22.6-7.1-39-28.2-39-53.1v-33.4c0-30.7,25-55.7,55.7-55.7s55.7,25,55.7,55.7V272.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr);
export default __webpack_public_path__ + "static/media/er.13cbf6391c4082204de0f85d2298ffc6.svg";
export { ForwardRef as ReactComponent };